export const storageKeys = {
    REDIRECT_URL: 'redirectUrl',
};